import {
  AppleFilled,
  GoogleCircleFilled,
  MobileFilled,
} from '@ant-design/icons'
import { Tag } from 'antd'
import { ReactNode } from 'react'

export type WalletTagPlatform = 'apple' | 'google' | 'app'

export interface WalletFieldTag {
  platform: WalletTagPlatform
  /**
   * Whether the value is required or optional on that platform. Omit when it
   * simply appears with no required/optional distinction (colors, images).
   */
  requirement?: 'required' | 'optional'
}

const PLATFORM_META: Record<
  WalletTagPlatform,
  { label: string; icon: ReactNode }
> = {
  apple: { label: 'Apple', icon: <AppleFilled /> },
  google: { label: 'Google', icon: <GoogleCircleFilled /> },
  app: { label: 'App', icon: <MobileFilled /> },
}

/**
 * Compact chips saying which pass surfaces a field appears on, and whether it
 * is required or optional there — the tag form of what used to be prose like
 * "Apple only" / "required for Android". A `required` chip is tinted so the
 * must-fill cases stand out; everything else is neutral.
 */
const WalletFieldTags = ({ tags }: { tags: WalletFieldTag[] }) => (
  <span style={{ display: 'inline-flex', flexWrap: 'wrap', gap: 4 }}>
    {tags.map(({ platform, requirement }) => {
      const meta = PLATFORM_META[platform]

      return (
        <Tag
          key={platform}
          icon={meta.icon}
          color={requirement === 'required' ? 'blue' : 'default'}
          style={{
            fontSize: 11,
            lineHeight: '18px',
            paddingInline: 6,
            marginInlineEnd: 0,
          }}
        >
          {requirement ? `${meta.label} · ${requirement}` : meta.label}
        </Tag>
      )
    })}
  </span>
)

export default WalletFieldTags
